import { Directive, inject, input, output, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

import { DayOfWeekEnum } from '@connect-services/client/services/custom-date-adapter.service';
import {
    EN_DATE_FORMAT,
    EN_DATE_FORMAT_LABEL,
    TranslateService,
} from '@connect-services/client/services/translate.service';
import { LangEnum } from '@transloco-root/client/transloco-root.module';

@Directive()
export abstract class AbstractDateInputComponent<ControlType, InfoType> {
    public readonly edited = input<boolean>(false);
    public readonly info = input.required<InfoType>();
    public readonly onBlur = output<unknown>();
    public readonly value = input<unknown | null>(null);
    public readonly valueChange = output<unknown>();

    protected readonly control = new FormControl<ControlType | null>(null);
    protected readonly currentLang: string = inject(TranslateService).getCurrentLang();
    protected readonly dateAdapter = inject(DateAdapter);
    protected dateFormatPlaceholder: string = EN_DATE_FORMAT;
    protected readonly errorMessages = signal<string[]>([]);

    private readonly dateFormatLabel: string = inject(TranslateService).getDateFormatLabel();

    protected constructor() {
        this.dateAdapter.getFirstDayOfWeek = (): number =>
            this.currentLang === LangEnum.EN ? DayOfWeekEnum.SUNDAY : DayOfWeekEnum.MONDAY;
        this.dateAdapter.setLocale(this.currentLang);
        this.dateFormatPlaceholder = this.dateFormatLabel ?? EN_DATE_FORMAT_LABEL;
    }

    protected abstract handleBlur(): void;
    protected abstract onDateChange(event: MatDatepickerInputEvent<Date>): void;
}
